import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { ActivatedRoute } from '@angular/router';
import { PARAMS } from 'src/app/_configs/params';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-explore-by-authority',
  templateUrl: './explore-by-authority.component.html',
  styleUrls: ['./explore-by-authority.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class ExploreByAuthorityTendersComponent implements OnInit {

  closingSoonTenders: Array<any> = [];
  baseUrl: string = environment.TENDER.BASE_URL;

  constructor(
    private transferState: TransferState,
    private sharedService: SharedService, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.resolveTenderNewMain();
  }

  resolveTenderNewMain() {
    this.activatedRoute.data.subscribe((rawData: any) => {
     

      let tendersResolver: any = rawData['tendersResolver'];
      // let resolverData: any = rawData?.homePageResolver;
      if (tendersResolver) {
        this.closingSoonTenders = tendersResolver?.authorities?.data;
        // this.closingSoonTenders = rawData?.homePageResolver?.authorities?.data;
      } else {
        const ALL_LISTING_AUTHORITY: any = makeStateKey<object>(PARAMS.STATIC_PARAMS.AUTHORITY);
        this.sharedService.retrieveAuthorityListTendersNew()
          .subscribe((res: any) => {
            
            this.closingSoonTenders = res?.data;
            if (this.sharedService.isServer) {
              this.transferState.set(ALL_LISTING_AUTHORITY, this.closingSoonTenders);
            }
          });
      }
    });
  }
}
